import { useEffect, useState, useRef } from "react";
import Pagination from "../Pagination";
import { IoSearchOutline } from "react-icons/io5";
import { useAppDispatch } from "../../redux/hooks";
import { getOutrightUsers, getAllOutrightUsers } from "../../redux/thunk";
import LoadingSpinner from "../elements/LoadingSpinner";
import { FaPhone, FaWhatsapp, FaRegCopy } from "react-icons/fa6";
import toast from "react-hot-toast";


const OutrightCustomers = ({
  status,
  isLoadingDelete,
  handleDeleteClick,
}: any) => {
  const [searchedUser, setSearchedUser] = useState("");
  const [outright, setOutright] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [itemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const dispatch = useAppDispatch();
  const adminLevel = localStorage.getItem("adminLevel");

  useEffect(() => {
    setIsLoading(true);
    const handler = setTimeout(() => {
      Promise.resolve(
        dispatch(
          getOutrightUsers({
            page: currentPage,
            limit: itemsPerPage,
            search: searchedUser
          })
        )
      ).then((response: any) => {
        setOutright(response?.payload?.results || []);
        setCurrentPage(response?.payload?.pagination?.currentPage || 1);
        setTotalPages(response?.payload?.pagination?.totalPages || 1);
        setTotalResults(response?.payload?.pagination?.totalResults || 0);
        setIsLoading(false);
      });
    }, 500); // 500ms debounce

    return () => clearTimeout(handler);
  }, [dispatch, currentPage, itemsPerPage, searchedUser]);

  // Reset to page 1 when search changes
  useEffect(() => {
    setCurrentPage(1);
  }, [searchedUser]);

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const goToPage = async (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  const searchForUsersWithEmail = (value: string) => {
    setSearchedUser(value);
  };

  const handleCopyClick = async (text: any) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const data = outright;

  return (
    <div className="bg-white rounded-md shadow-md pb-6">
      <div
        className={`w-full overflow-x-auto ${
          status === "loading" && "animate-pulse h-[50vh]"
        }`}
      >
        <div
          className="flex items-center justify-between p-6"
          style={{ minWidth: "700px" }}
        >
          <div className="flex justify-between w-full">
            <h1 className="text-base font-semibold ">Outright Customers</h1>
            <div className="relative md:w-[30rem] w-fit">
              <IoSearchOutline className="w-6 h-6 absolute top-[0.6rem] left-2 text-gray-300" />
              <input
                type="search"
                name="searchedUser"
                id="searchedUser"
                value={searchedUser}
                onChange={(e) => searchForUsersWithEmail(e.target.value)}
                placeholder="Search user using email"
                className="border p-2 text-sm rounded-md indent-7 w-full"
                disabled={outright && outright.length === 0}
              />
            </div>
          </div>
        </div>
        <section className="overflow-x-auto">
          <table className="w-[1020px]" style={{ minWidth: "700px" }}>
            <thead className="bg-gray-50 font-bold p-4 text-left">
              <tr>
                <th className="p-2 ">S/N</th>
                <th className="p-2">Name</th>
                <th className="p-2">Email</th>
                <th className="p-2">Phone</th>
                <th className="p-2">Contact</th>
                <th className="p-2">Address</th>
                <th className="p-2 text-nowrap">Verification stage</th>
                {adminLevel === "superadmin" && (
                  <>
                    <th className="p-2 text-nowrap">Open Password</th>
                    <th className="p-2 text-nowrap">Force Delete User</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody className="px-4">
              {isLoading ? (
                <tr>
                  <td colSpan={7} className="text-center p-3">
                    <LoadingSpinner />
                  </td>
                </tr>
              ) : data && data.length > 0 ? (
                data.map((data: any, index: number) => {
                  return (
                    <tr className="border-b border-gray-300 py-2" key={index}>
                      <td className="text-secondary p-2">
                        {index + ((currentPage - 1) * itemsPerPage + 1)}
                      </td>
                      <td className="p-2 text-nowrap">
                        {data.firstName ? data.lastName : null}{" "}
                        {data.lastName ? data.firstName : null}
                      </td>
                      <td className="p-2">
                        <div className="flex gap-2 justify-between items-center">
                          <p>{data.email}</p>
                          {data.email && (
                            <button
                              type="button"
                              className="mr-3"
                              onClick={() => handleCopyClick(data.email)}
                            >
                              <FaRegCopy className="w-5 h-5 text-gray-500 hover:text-secondary transition-colors" />
                            </button>
                          )}
                        </div>
                      </td>
                      <td className="p-2 text-nowrap">
                        <div className="flex gap-2 justify-between items-center">
                          <p>{data?.phoneNumber || "No number"}</p>
                          {data?.phoneNumber && (
                            <button
                              type="button"
                              className="mr-3"
                              onClick={() => handleCopyClick(data.phoneNumber)}
                            >
                              <FaRegCopy className="w-5 h-5 text-gray-500 hover:text-secondary transition-colors" />
                            </button>
                          )}
                        </div>
                      </td>
                      <td className="p-2">
                        <button
                          className="mr-3"
                          type="button"
                          title="call customer"
                        >
                          <a href={`tel:${data?.phoneNumber}`}>
                            <FaPhone />
                          </a>
                        </button>
                        <button type="button" title="text via whatsapp">
                          <a
                            href={`https://wa.me/${data?.phoneNumber?.replace(
                              /^0/,
                              "234"
                            )}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <FaWhatsapp />
                          </a>
                        </button>
                      </td>
                      <td className="p-2 text-nowrap">
                        {data.deliveryAddress ? data.deliveryAddress : null}
                      </td>
                      <td className="p-2 text-nowrap">{data.isComplete}</td>
                      {adminLevel === "superadmin" ? (
                        <>
                          <td className="p-2">
                            {data.userPassword
                              ? data.userPassword
                              : "not found"}
                          </td>
                          <td className="p-2 text-center">
                            <button
                              type="button"
                              className={`${
                                isLoadingDelete ? "bg-red-100" : "bg-red-600"
                              } p-2 text-sm text-white rounded-md`}
                              onClick={() => handleDeleteClick(data)}
                              disabled={isLoadingDelete}
                            >
                              Delete
                            </button>
                          </td>
                        </>
                      ) : null}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={7} className="text-center text-secondary p-3">
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </div>
      <section className="p-3 my-5">
        <Pagination
          length={totalResults}
          itemsPerPage={itemsPerPage}
          handlePagination={goToPage}
          currentPage={currentPage}
          prevPage={prevPage}
          nextPage={nextPage}
          responseTotalPages={totalPages}
        />
      </section>
    </div>
  );
};

export default OutrightCustomers;
